var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_519_29206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1668 9.99161L17.1334 7.66661L17.4168 4.59161L14.4084 3.90827L12.8334 1.24994L10.0001 2.46661L7.16678 1.24994L5.59178 3.90827L2.58344 4.58327L2.86678 7.66661L0.833443 9.99161L2.86678 12.3166L2.58344 15.3999L5.59178 16.0833L7.16678 18.7499L10.0001 17.5249L12.8334 18.7416L14.4084 16.0833L17.4168 15.3999L17.1334 12.3249L19.1668 9.99161ZM15.8751 11.2249L15.4084 11.7666L15.4751 12.4749L15.6251 14.0999L14.0418 14.4583L13.3418 14.6166L12.9751 15.2333L12.1501 16.6333L10.6668 15.9916L10.0001 15.7083L9.34178 15.9916L7.85844 16.6333L7.03344 15.2416L6.66678 14.6249L5.96678 14.4666L4.38344 14.1083L4.53344 12.4749L4.60011 11.7666L4.13344 11.2249L3.05844 9.99994L4.13344 8.76661L4.60011 8.22494L4.52511 7.50827L4.37511 5.89161L5.95844 5.53327L6.65844 5.37494L7.02511 4.75827L7.85011 3.35827L9.33344 3.99994L10.0001 4.28327L10.6584 3.99994L12.1418 3.35827L12.9668 4.75827L13.3334 5.37494L14.0334 5.53327L15.6168 5.89161L15.4668 7.51661L15.4001 8.22494L15.8668 8.76661L16.9418 9.99161L15.8751 11.2249Z",
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.143 10C17.143 13.9449 13.945 17.1429 10.0001 17.1429C6.05521 17.1429 2.85725 13.9449 2.85725 10C2.85725 6.05514 6.05521 2.85718 10.0001 2.85718C13.945 2.85718 17.143 6.05514 17.143 10Z",
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78132 11.1741L6.90893 9.29361L5.71447 10.4961L8.78132 13.5711L14.7052 7.63105L13.5107 6.42853L8.78132 11.1741Z",
    fill: "#F8FAFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_519_29206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verified_icon.ab08475956037b1f4dccd6a6728f8ff8.svg";
export { ForwardRef as ReactComponent };